import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

import logo, { logoOnDark } from "../assets/logo.js";
import { useHomeVideo } from "../config/HomeVideos";
import { useNavDirection } from "../NavDirectionContext";

export default function Home() {
  const navigate = useNavigate();
  const { setDir } = useNavDirection();

  // La vidéo de fond est rendue par App, une seule fois et hors de la
  // transition de page — voir le commentaire dans App.js. Cette page n'a plus
  // besoin que de darkText, pour accorder l'encre à la vidéo affichée.
  const { darkText } = useHomeVideo();

  const goShop = () => {
    setDir("up");
    navigate("/shop");
  };

  return (
    <div className={`homeClean${darkText ? " homeClean--darkText" : ""}`}>
      <div className="homeClean__center">
        <button className="homeClean__logoBtn" onClick={() => navigate("/")}>
          {/* Le contenu est posé sur la vidéo, à toutes les largeurs : encre
              claire par défaut, encre sombre seulement pour les vidéos
              déclarées claires dans VIDEOS_WITH_DARK_TEXT.
              Jusqu'au 20/09/2026 l'encre claire n'existait que sous 520 px, via
              un <picture> : sur desktop le logo et le menu restaient sombres
              quelle que soit la vidéo, et devenaient illisibles.
              Même logique que ClosedPreDrop, pour que les deux ne divergent pas. */}
          <img
            className="homeClean__logo"
            src={darkText ? logo : logoOnDark}
            alt="Ghetto Symphony"
          />
        </button>

        <nav className="homeClean__menu">
          <button className="homeClean__link" onClick={goShop}>
            shop
          </button>

          <button
            className="homeClean__link"
            onClick={() => {
              setDir("up");
              navigate("/subscribe");
            }}
          >
            subscribe
          </button>

          <button
            className="homeClean__link"
            onClick={() => {
              setDir("up");
              navigate("/contact");
            }}
          >
            contact
          </button>
        </nav>
      </div>
    </div>
  );
}